import 'accounting';

import '../../../stylesheets/forms/forms.scss';

import './shared';

import Utility from 'Legacy/helpers/shared/utility';
import Dialog from 'Legacy/components/shared/dialog';

// Load third-party bower assets


// Load one-off admin portal components
import 'Legacy/components/payment/cryptpay';
import 'Legacy/components/payment/payment';
import 'Legacy/components/payment/nmi_redirect';
import 'Legacy/helpers/shared/buttons';
import 'Legacy/admin_portal/dropdown';
import 'Legacy/helpers/shared/ajax_populate';
import 'Legacy/helpers/shared/x_editable_fix';

// Load SchoolAdmin form-specific code
import '../forms/modules/custom_form';
import '../forms/modules/set_button_actions';
import '../forms/modules/toggle_option';

global.Dialog = Dialog;
global.Utility = Utility;
